import mqtt from 'mqtt'
import {
  mqttUrl,
  mqttUsername,
  mqttPassword,
  mqttClientId,
} from '@/constants/config'

let client

export const connectMQTT = () => {
  client = mqtt.connect(mqttUrl, {
    port: 443,
    protocol: 'wss',
    username: mqttUsername,
    password: mqttPassword,
    clientId:
      `${mqttClientId
      }_${
        Math.random().toString(16).substr(2, 8)}`,
    clean: true,
    reconnectPeriod: 1000,
    connectTimeout: 30000,
  })

  return client
}

export const sendTrigger = (mqttIp, bucket) => {
  if (!client || !client.connected) {
    return
  }

  client.publish(
    `${mqttIp}/trigger`,
    JSON.stringify({
      action: 'trigger',
      bucket,
      time: new Date().toLocaleString('sv-SE'),
    }),
    { qos: 0 },
  )
}
